<template>
  <div class="account-check-popup-container">
    <vix-suspend-menu :show="show">
      <div class="account-check-popup" :class="className">
        <div class="background-gradient"></div>
        <div class="popup-close" @click="handleClose"></div>
        <div class="popup-title">{{ title }}</div>
        <div class="popup-body">{{ content }}</div>
        <img v-if="imageUrl" :src="imageUrl" class="popup-image" alt="illustration" />
        <div class="popup-buttons">
          <div class="popup-button primary" @click="handleConfirm">{{ confirmButton }}</div>
          <div v-if="cancelButton" class="popup-button secondary" @click="handleCancel">{{ cancelButton }}</div>
        </div>
      </div>
    </vix-suspend-menu>
  </div>
</template>

<script>
import { SuspendMenu as VixSuspendMenu } from '@mx/vix';
import '@mx/vix/suspend-menu/style';

export default {
  name: 'AccountCheckPopup',
  components: {
    VixSuspendMenu,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    confirmButton: {
      type: String,
      required: true,
    },
    cancelButton: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
  emits: ['confirm', 'cancel', 'closeSlider'],
  methods: {
    handleClose() {
      this.$emit('closeSlider');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="less" scoped>
.account-check-popup-container {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 100; // 需要挡住 PGY 的横幅组件

  /deep/ .suspend-menu-box {
    padding: 0;
    background: #ffffff;
    border-radius: 0.4rem 0.4rem 0 0;
    padding-bottom: 0.6rem;
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
  }
  /deep/ .suspend-menu-mask {
    background: rgba(0, 0, 0, 0.7);
  }
}
.account-check-popup {
  position: relative;
  width: 100%;
  padding: 0.58rem 0.24rem 0;
  background-color: #fff;
  border-radius: 0.4rem 0.4rem 0 0;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;

  .background-gradient {
    background: linear-gradient(0deg, #ffffff00 0%, #ffffff00 38%, #fffdde38 71%, #fff68a47 100%);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6.2rem;
  }

  .popup-close {
    position: absolute;
    top: 0.36rem;
    right: 0.24rem;
    height: 0.36rem;
    width: 0.36rem;
    z-index: 2;

    background: url('https://p1.meituan.net/wxapp/112bb969dc5f7939d40ec8ed1b90c25c479.png') 100% / contain no-repeat;
  }

  .popup-title {
    white-space: pre-line;
    position: relative;
    z-index: 1;
    padding: 0 0.24rem;

    font-weight: 400;
    color: rgba(0, 0, 0, 0.9);
    font-family: MEITUANTYPE-REGULAR, sans-serif;
    font-size: 0.48rem;
    line-height: 0.61rem;
    text-align: left;
  }

  .popup-body {
    margin-top: 0.08rem;
    position: relative;
    z-index: 1;
    margin-top: 0.21rem;
    padding: 0 0.24rem;

    font-weight: 400;
    color: #888888;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 0.22rem;
    line-height: 0.33rem;
    text-align: justify;
  }

  .popup-image {
    position: relative;
    z-index: 1;
    width: 6.53rem;
    margin: 0.53rem auto 0.19rem;
    pointer-events: none;
  }

  .popup-buttons {
    position: relative;
    z-index: 1;
    margin-top: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .popup-button {
      width: 100%;
      text-align: center;

      &.primary {
        background: linear-gradient(97deg, #ffe74d 0%, #ffdd00 100%);
        height: 0.8rem;
        line-height: 0.8rem;
        border-radius: 0.4rem;

        color: #111111;
        font-weight: 500;
        font-size: 0.3rem;
        text-align: center;
      }

      &.secondary {
        background-color: transparent;
        padding-bottom: 0.25rem;

        margin-top: 0.26rem;
        font-weight: 400;
        color: #888888;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.28rem;
        line-height: 0.4rem;
        text-align: center;
      }
    }
  }
}
</style>
